// extracted by mini-css-extract-plugin
module.exports = {"TitleBarTwoIconsLink":"TitleBarTwoIconsLink_TitleBarTwoIconsLink__1PSa8","text":"TitleBarTwoIconsLink_text__10pKu","titleText":"TitleBarTwoIconsLink_titleText__3xH1e"};